var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 48,
    viewBox: "0 0 30 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53377 47.8547C5.1244 48.1463 5.84187 47.9895 6.25577 47.4704L28.7558 19.2517C29.0925 18.8293 29.1576 18.2514 28.9232 17.7648C28.6888 17.2781 28.1965 16.9688 27.6563 16.9688H18.6761L26.103 2.03241C26.3198 1.59647 26.2957 1.07944 26.0392 0.665625C25.7829 0.251812 25.3305 0 24.8438 0H7.96877C7.32293 0 6.76015 0.439875 6.60415 1.0665L0.979146 23.6603C0.874615 24.0802 0.969302 24.525 1.23574 24.866C1.50227 25.207 1.91102 25.4062 2.34377 25.4062H8.98202L3.79174 46.254C3.6319 46.8957 3.9408 47.562 4.53377 47.8547ZM12.1459 24.3397C12.2504 23.9198 12.1557 23.475 11.8893 23.134C11.6228 22.793 11.214 22.5938 10.7813 22.5938H4.14302L9.0678 2.8125H22.5739L15.1469 17.7488C14.9302 18.1848 14.9543 18.7018 15.2108 19.1156C15.4671 19.5295 15.9194 19.7812 16.4062 19.7812H24.7363L8.07977 40.6714L12.1459 24.3397Z",
    fill: "#9AA8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.c459f860f78d5d629204b6353a046d72.svg";
export { ForwardRef as ReactComponent };